import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "status-icon",
  templateUrl: "status-icon.component.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class StatusIcon {
  protected status = input.required<string>();
}
